import { render, staticRenderFns } from "./ver.vue?vue&type=template&id=0e08e9f0&scoped=true"
import script from "./ver.vue?vue&type=script&lang=js"
export * from "./ver.vue?vue&type=script&lang=js"
import style0 from "./ver.vue?vue&type=style&index=0&id=0e08e9f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e08e9f0",
  null
  
)

export default component.exports